import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useLazyQuery } from "@apollo/client";

// Custom.
import Wrapper from "../Content/Wrapper";
import Report from "../Content/Report";
import Row from "../Content/Row";
import Header from "../Content/Header";
import { GET_STATISTICS_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS } from "api";
import { GeneralObject } from "@vocollege/app/dist/global";
import VoLoader from "@vocollege/components/dist/VoLoader";
import Stack from "@mui/material/Stack";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { DownloadExcelButtonProps } from "@vocollege/components/dist/DownloadExcelButton";
import { getExcelData } from "./Utils";

const StatisticsLanguageRepresentativeEducatorDiplomas: React.FC = () => {
  const [excelData, setExcelData] = useState<DownloadExcelButtonProps | null>(
    null,
  );

  // Methods.

  const handleHeaderChange = (params: GeneralObject) => {
    loadQuery({
      variables: {
        from: params.from,
        to: params.to,
        groupBy: params.groupBy,
      },
    });
  };

  // Api.

  const [loadQuery, { data, loading, variables }] = useLazyQuery(
    GET_STATISTICS_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS,
    {
      fetchPolicy: "network-only",
    },
  );

  // Effects.

  useEffect(() => {
    if (data) {
      setExcelData(
        getExcelData(
          data,
          JSON.parse(
            data?.certStatisticsLanguageRepresentativeEducatorDiplomas.data,
          ),
          variables,
        ),
      );
    }
  }, [data, variables]);

  return (
    <Wrapper
      title={
        I18n.get.languageRepresentativeEducatorDiploma.labels
          .languageRepresentativeEducatorDiplomas
      }
      hideTitleOnPrint
    >
      <Header
        filters={["from", "to"]}
        groupBy={[]}
        onChange={handleHeaderChange}
        excel={excelData || undefined}
      />
      {!loading && data && (
        <Box
          sx={{
            mt: 4,
            "@media print": {
              mt: 0,
            },
          }}
        >
          <Report
            title={I18n.get.languageRepresentativeEducatorDiploma.label}
            date={
              data?.certStatisticsLanguageRepresentativeEducatorDiplomas
                .createdAt
            }
            interval={`${variables?.from} - ${variables?.to}`}
          >
            <Stack>
              <Row
                label={I18n.get.vocertStatistics.quantity}
                value={
                  JSON.parse(
                    data?.certStatisticsLanguageRepresentativeEducatorDiplomas
                      .data,
                  ).length
                }
              />
            </Stack>
          </Report>
        </Box>
      )}
      {loading && <VoLoader />}
    </Wrapper>
  );
};

export default StatisticsLanguageRepresentativeEducatorDiplomas;
